import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconHistory: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconHistory"><Path d="M12 7.5V12L16 16" stroke="currentColor" strokeLinecap="square"/><Path d="M2.5 4.5V8.5H6.5" stroke="currentColor" strokeLinecap="square"/><Path d="M3 15.1667C4.30701 18.8564 7.83367 21.5 11.9791 21.5C17.2374 21.5 21.5 17.2467 21.5 12C21.5 6.75329 17.2374 2.5 11.9791 2.5C8.03414 2.5 4.64955 4.89406 3.20501 8.30556" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconHistory;
